jQuery(document).ready(function ($) {
  const searchFaqs = () => {
    $.extend($.expr[':'], {
      containsIN: function (elem, i, match, array) {
        return (
          (elem.textContent || elem.innerText || '')
            .toLowerCase()
            .indexOf((match[3] || '').toLowerCase()) >= 0
        );
      },
    });

    const q = $('#q').val();
    if (q) {
      $('.faq').hide();
      $('[id^=answer]').hide();
      const myMatches = $('[id^=answer]:containsIN(' + q + ')');
      $('.faq-message').html(myMatches.length + ' results found');
      myMatches.parents('.faq').show();
    } else {
      $('.faq-message').html('');
      $('.faq').show();
      $('[id^=answer]').hide();
    }
  };

  $('.faq-question-text').on('click touch', function (e) {
    $('#answer-' + this.getAttribute('data-id')).toggle(100);
  });

  $('.faq-search__button').on('click', searchFaqs());

  $('.faq-reset__button').click(function () {
    $('.faq-message').html('');
    $('#q').val('');
    $('.faq').show();
    $('[id^=answer]').hide();
  });

  $('.faq-search').on('keyup keypress', function (e) {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      e.preventDefault();
      searchFaqs();
      return false;
    } else {
      searchFaqs();
    }
  });
});
